import { render, staticRenderFns } from "./TraxSettingTaskCrudTable.vue?vue&type=template&id=3f65735c"
import script from "./TraxSettingTaskCrudTable.vue?vue&type=script&lang=js"
export * from "./TraxSettingTaskCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports